// IE support for document.querySelectorAll('foo').forEach(()=>{..}) without Array.from() wrapper
if (typeof window !== 'undefined' && window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}
